import { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import './Breadcrumb.css';

// items: [{ label: string, to?: string }]
// Items with `to` render as links; items without render as plain text (current page).
const Breadcrumb = ({ items }) => (
  <div className="breadcrumb">
    {items.map((item, idx) => (
      <Fragment key={idx}>
        {idx > 0 && <span className="breadcrumb-sep">&gt;</span>}
        {item.to
          ? <NavLink to={item.to} className="breadcrumb-link">{item.label}</NavLink>
          : <span className="breadcrumb-current">{item.label}</span>
        }
      </Fragment>
    ))}
  </div>
);

export default Breadcrumb;
